/* eslint-disable no-param-reassign */
class PageReport {
  subPageReportMap = {};

  isFirstLoadReport = false;

  getSubPageLoadState(path) {
    return new Promise((resolve) => {
      const timer = setInterval(() => {
        if (window.__component_load_state__) {
          const target = Object.values(window.__component_load_state__).find((item) => path === item.path);
          if (target) {
            clearInterval(timer);
            resolve(target);
          }
        }
      }, 500);
    });
  }

  getReportFirstLoadCost() {
    return new Promise((resolve) => {
      const timer = setInterval(() => {
        if (window.loadingCost) {
          clearInterval(timer);
          resolve(window.loadingCost);
        }
      }, 500);
    });
  }

  report(event) {
    try {
      const curPath = new URL(event.request.url).pathname;
      if (!this.isFirstLoadReport) {
        this.isFirstLoadReport = true;
        this.subPageReportMap[curPath] = true;

        return Promise.all([this.getReportFirstLoadCost(), this.getSubPageLoadState(curPath)]).then(
          ([loadingCost, subPageLoadState]) => {
            const { timestamp } = subPageLoadState;
            const firstPageLoad = timestamp - performance.timing.navigationStart;
            event.measurements['connection.rtt'] = {
              unit: 'millisecond',
              value: loadingCost > firstPageLoad ? loadingCost : firstPageLoad,
            };
            return event;
          },
        );
      } else if (!this.subPageReportMap[curPath]) {
        this.subPageReportMap[curPath] = true;
        return this.getSubPageLoadState(curPath).then((state) => {
          event.measurements = {};
          event.measurements['connection.rtt'] = {
            unit: 'millisecond',
            value: state.cost,
          };
          return event;
        });
      }
      return event;
    } catch (err) {
      return event;
    }
  }
}

const pageReporter = new PageReport();

export default pageReporter;
